var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M7.446 16a.666.666 0 0 1-.473-.193L1.526 10.36a3.333 3.333 0 0 1 0-4.72L6.973.193a.67.67 0 0 1 .947.947L2.473 6.587a2 2 0 0 0 0 2.826L7.92 14.86A.667.667 0 0 1 7.446 16Z",
  fill: "currentColor"
})));
export default SvgArrow;